import React, {
  useEffect,
  useState,
  memo,
  useMemo,
  useRef,
  useCallback,
} from "react";
import tick from "../../images/check-mark@2x.png";
import { Stack, TableBody, Table, Grid, Button, styled } from "@mui/material";
import { FormControl, MenuItem, InputLabel, Select, Box } from "@mui/material";
import { TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getVendors } from "../vendors/vendorSlice";
import { useHistory } from "react-router-dom";
import { addItem } from "./saleSlice";
import { clearSelected, editItem, removeItem } from "./saleSlice";
import { toast } from "react-toastify";
import { editSearchedItem, getItems } from "../inventory/itemsSlice";
import ItemsRepository from "../../Repository/ItemsRepository";
import { updateItemsDisc } from "../inventory/httpCalls";
import { editFeature } from "../features/SaleItemEditing";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import SearchNew from "../components/SearchNew";
import Loader from "../components/Loader";
import { RFTfeature } from "../features/RFTfeature";
import { BoxesPacking } from "../features/BoxesPacking";
import _ from "lodash";
import { Toast } from "../components/Toast";

const ItemBox = styled(Box)({
  padding: "5px",
  borderRadius: "15px",
  minHeight: "80px",
  marginTop: "10px",
  marginBottom: "10px",
  boxShadow: "0px 2px 5px #c2c1c1",
  transitionDuration: "0.2s",
  backgroundColor: "#ffffff",
  display: "grid",
  gridTemplateColumns: "8% 92%",
  color: "#5f5f5f",
  cursor: "pointer",
});

const Row = memo(
  ({
    item,
    index,
    handleSelection,
    companyCode,
    editFeature,
    checkIds,
    handleUpdate,
    handleEdit,
    BoxesPacking,
    RFTfeature,
    handleKeyUp,
    selectedItems,
    tokenType,
    costPriceShow,
    costPriceBatchInside,
    salePriceBatchInside,
  }) => {
    let qty =
      item.weightType == true
        ? parseFloat(item.weight)
        : parseFloat(item.quantity);
    let itemQty = item.itemQuantityInBatches
      ? item.itemQuantityInBatches
      : qty % 1 === 0
      ? qty
      : qty.toFixed(3);
    let qtyType = item.weightType == true ? "Weight" : "Quantity";
    let saleQty;
    if (checkIds[item._id]) {
      let found = selectedItems.find((i) => i._id == item._id);
      if (found.saleQuantity) {
        saleQty = found.saleQuantity;
      }
    }
    let decimal = qty - Math.floor(qty);

    return (
      <ItemBox key={index}>
        <img
          src={checkIds[item._id] ? tick : ""}
          className="tick center"
          style={{ margin: "auto" }}
          onClick={() => handleSelection(item)}
        />
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {companyCode == 7653 ? (
            <>
              <Grid
                item
                md={5}
                xs={12}
                onClick={() => handleSelection(item)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" className="font-xs-12">
                  {item.name}
                </Typography>
              </Grid>
              <Grid
                item
                md={5}
                xs={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => handleSelection(item)}
              >
                <Stack>
                  <Typography>Description:</Typography>
                  <Typography>{item.description}</Typography>
                </Stack>
              </Grid>
              <Grid
                item
                md={1.5}
                xs={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => handleSelection(item)}
              >
                <Stack>
                  <Typography className="font-xs-12">Sale Price:</Typography>
                  <Typography className="font-xs-12">
                    <b className="font-xs-12">
                      {item.price || salePriceBatchInside}
                    </b>
                  </Typography>
                </Stack>
              </Grid>
            </>
          ) : (
            <>
              {editFeature() ? (
                <>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    onClick={() => handleSelection(item)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h6" className="font-xs-12">
                      {item.name}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    onClick={() => handleSelection(item)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Stack width="100%" direction="row" spacing={1}>
                      {checkIds[item._id] && (
                        <Stack alignItems="center" justifyContent="center">
                          <Typography className="font-xs-12">
                            Sale Qty
                          </Typography>
                          <input
                            size="small"
                            variant="outlined"
                            type="number"
                            name="saleQuantity"
                            style={{ width: "100%", height: "20px" }}
                            value={item.saleQuantity || saleQty || ""}
                            onKeyUp={handleKeyUp}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleUpdate(item, "saleQuantity", index);
                              }
                            }}
                            onChange={(e) => handleEdit(e, index, item)}
                          />
                        </Stack>
                      )}

                      <Stack alignItems="center" justifyContent="center">
                        <Typography className="font-xs-12">Code</Typography>
                        <input
                          size="small"
                          variant="outlined"
                          type="number"
                          name="itemCode"
                          style={{
                            textAlign: "center",
                            width: "100%",
                            height: "20px",
                          }}
                          value={item.itemCode ? item.itemCode : item.itemId}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleUpdate(item, "itemCode", index);
                            }
                          }}
                          onKeyUp={handleKeyUp}
                          onChange={(e) => handleEdit(e, index, item)}
                        />
                      </Stack>
                      <Stack alignItems="center" justifyContent="center">
                        <Typography className="font-xs-12">
                          Sale Price
                        </Typography>
                        <input
                          size="small"
                          variant="outlined"
                          type="number"
                          name="price"
                          style={{
                            textAlign: "center",
                            width: "100%",
                            height: "20px",
                          }}
                          value={item.price}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleUpdate(item, "price", index);
                            }
                          }}
                          onKeyUp={handleKeyUp}
                          onChange={(e) => handleEdit(e, index, item)}
                        />
                      </Stack>
                      {costPriceShow && (
                        <Stack alignItems="center" justifyContent="center">
                          <Typography className="font-xs-12">
                            Cost Price
                          </Typography>
                          <input
                            size="small"
                            variant="outlined"
                            type="number"
                            name="costPrice"
                            style={{
                              textAlign: "center",
                              width: "100%",
                              height: "20px",
                            }}
                            value={item.costPrice}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleUpdate(item, "costPrice", index);
                              }
                            }}
                            onKeyUp={handleKeyUp}
                            onChange={(e) => handleEdit(e, index, item)}
                          />
                        </Stack>
                      )}
                    </Stack>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={8}>
                    <Grid container>
                      <Grid
                        item
                        md={6}
                        xs={4}
                        onClick={() => handleSelection(item)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="h6" className="font-xs-12">
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        md={2}
                        xs={6}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => handleSelection(item)}
                      >
                        <Stack>
                          <Typography className="font-xs-12">
                            Description:
                          </Typography>
                          <Typography>
                            <b>{item.description}</b>
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid
                        item
                        md={1.5}
                        xs={2}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => handleSelection(item)}
                      >
                        <Stack>
                          <Typography className="font-xs-12">Code:</Typography>
                          <Typography>
                            <b>{item.itemCode || item.itemId}</b>
                          </Typography>
                        </Stack>
                      </Grid>
                      {item.shop_code && (
                        <Grid
                          item
                          md={2}
                          xs={6}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() => handleSelection(item)}
                        >
                          <Stack>
                            <Typography className="font-xs-12">
                              Warehouse:
                            </Typography>
                            <Typography>
                              <b>{item.shop_code?.shopName}</b>
                            </Typography>
                          </Stack>
                        </Grid>
                      )}
                      <Grid
                        item
                        md={1}
                        xs={4}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => handleSelection(item)}
                      >
                        <Stack>
                          <Typography className="font-xs-12">
                            Sale Price:
                          </Typography>
                          <Typography
                            sx={{
                              textAlign: { xs: "left", md: "center" },
                              fontWeight: "bold",
                            }}
                          >
                            {item.price || salePriceBatchInside}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid
                        item
                        md={1.5}
                        xs={4}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => handleSelection(item)}
                      >
                        {costPriceShow && (
                          <Stack>
                            <Typography className="font-xs-12">
                              Cost Price:
                            </Typography>
                            <Typography
                              sx={{
                                textAlign: { xs: "left", md: "center" },
                                fontWeight: "bold",
                              }}
                            >
                              {item.costPrice || costPriceBatchInside}
                            </Typography>
                          </Stack>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </>
          )}
          <Grid item xs={1.5} sx={{ marginTop: { xs: "50px", md: "0px" } }}>
            <Stack alignItems="center" justifyContent="center">
              <Typography
                sx={{ color: "#4eaf51" }}
                variant="h6"
                className="font-xs-12"
              >
                {qtyType}
              </Typography>
              {editFeature() ? (
                <input
                  size="small"
                  type="number"
                  name="quantity"
                  style={{
                    textAlign: "center",
                    width: "80px",
                    height: "20px",
                  }}
                  value={itemQty}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleUpdate(item, "quantity", index);
                    }
                  }}
                  onKeyUp={handleKeyUp}
                  onChange={(e) => handleEdit(e, index, item)}
                />
              ) : (
                <>
                  <Typography>{itemQty}</Typography>
                  {BoxesPacking() && item?.boxes && (
                    <Typography variant="subtitle2">
                      Boxes:
                      {item.boxes % 1 === 0
                        ? item.boxes
                        : item.boxes.toFixed(2)}
                    </Typography>
                  )}
                </>
              )}
            </Stack>
            {RFTfeature() && item.unit === "Role" && (
              <Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="subtitle2" sx={{ color: "#4EAF51" }}>
                    Meters
                  </Typography>
                  <Typography variant="subtitle2">
                    {(decimal * 100).toFixed(4)}
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="subtitle2" sx={{ color: "#4EAF51" }}>
                    RFT
                  </Typography>
                  <Typography variant="subtitle2">
                    {(decimal * 328).toFixed(4)}
                  </Typography>
                </Stack>
              </Stack>
            )}
          </Grid>

          <Grid item xs={1.5} sx={{ marginTop: { xs: "50px", md: "0px" } }}>
            <Stack alignItems="center" justifyContent="center">
              {item.totalBoxes && (
                <Typography
                  sx={{ color: "#4eaf51" }}
                  variant="h6"
                  className="font-xs-12"
                >
                  {"T.Ctn"}
                </Typography>
              )}

              <Typography>{item?.totalBoxes}</Typography>
            </Stack>
          </Grid>
        </Grid>
      </ItemBox>
    );
  }
);

const SelectItems = memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const companyCode = localStorage.getItem("companyCode");
  const tokenType = localStorage.getItem("tokenType");

  const vendor = useSelector((state) => state.vendor);
  const selectedItems = useSelector((state) => state.sale.selected);
  const inventory = useSelector((state) => state.inventory.items);
  console.log("inventory", inventory);
  const loading = useSelector((state) => state.inventory.loading);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { company } = useSelector((state) => state.company);
  console.log("com");
  console.log("isonline", isOnline);
  const [state, setState] = useState({
    items: [],
    searchedItems: [],
    selected: [],
    searchKey: "",
    vendor: "all",
    isSearched: "",
    ref: true,
  });
  let token = localStorage.getItem("tokenType");

  const showCostPrice =
    token == "admin" ? true : company?.access?.includes("Cost Price");

  const updateOnlineStatus = () => {
    setIsOnline(navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    // Cleanup function to remove the event listeners when the component unmounts
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    if (isOnline == true) {
      if (vendor?.vendors?.length === 0) {
        dispatch(getVendors());
      }
      // if (inventory.length === 0) {
      // }
    }
  }, [vendor?.vendors?.length, isOnline]);
  useEffect(() => {
    dispatch(getItems());
    console.log("getitems");
  }, []);
  // useEffect(() => {
  //   if (!arraysAreEqual(state.items, inventory)) {
  //     console.log('useEffect')
  //     setState((prev) => ({
  //       ...prev,
  //       items: [...inventory],  // Ensure to create a new array
  //     }));
  //   }
  // }, [inventory]);

  const searchKeyRef = useRef(null);

  function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  const checkIds = selectedItems.reduce((acc, item) => {
    acc[item._id] = item._id;
    return acc;
  }, {});

  const handleSelection = (arg) => {
    let item = JSON.parse(JSON.stringify(arg));
    Number(item.price) < Number(item.costPrice)
      ? (item.priceComparison = "true")
      : (item.priceComparison = "false");
    // if (item.quantity <= 0) {
    //   return Toast("info", `${item?.name}Quantity Is ${item?.quantity}`);
    // }
    // if (item.saleQuantity > item.quantity) {
    //   return Toast(
    //     "info",
    //     `Cannot Sale More Quantity Then Stock ${item?.name} `
    //   );
    // }
    let found = selectedItems.find((i) => i._id == item._id);
    if (found) {
      let foundIndex = selectedItems.findIndex((i) => i._id == item._id);
      dispatch(removeItem({ index: foundIndex }));
    } else {
      dispatch(addItem(item));
    }
  };

  const getInventory = () => {
    dispatch(getInventory());
  };

  const handleSearch = async (value) => {
    // console.log(value, 'valll')
    let text = value;
    // console.log('val', value)
    // console.log('state.searchkey', state.searchKey)

    // if (value) {
    //   if (value !== "empty") {
    //     text = value;
    //   }
    // } else {
    //   text =  state.searchKey;
    //   console.log('state', state.searchKey)
    // }

    console.log("text", text);
    const items = inventory.filter((item) => {
      console.log("item", item);
      const name = item.name ? item.name.toString().toLowerCase() : "";
      const ItemId = item.itemId ? item.itemId.toString().toLowerCase() : "";
      const batchNumberSelected =
        Array.isArray(item.batchNumber) && item.batchNumber.length > 0
          ? item.batchNumber[0].batchNumber
          : "";
      const codeSearch = item?.itemId?.toString();
      const imeiNumber = item?.imeiNumber?.toString().trim().toLowerCase();
      console.log("imeiNumber", imeiNumber);
      console.log({ imeiNumber, text });

      console.log("selcted");
      // console.log('name',name)
      // console.log('code',ItemId )
      return (
        name.includes(text.toLowerCase()) ||
        ItemId.includes(text.toLowerCase()) ||
        item?.barCode?.includes(text) ||
        batchNumberSelected?.includes(text) ||
        codeSearch?.startsWith(text) ||
        imeiNumber?.includes(text.toLowerCase())
      );
    });

    //  console.log('items', items);
    //  const nearMatches = inventory.filter((item) => {
    //   console.log('str',item.name.substring(0))
    //   console.log('text',text.substring(0))
    //   return item.name.includes(text);
    // }
    // );
    //  console.log('nearMatches', nearMatches);

    console.log("batchNumber", items);

    let vendorName = state.vendor === "all" ? "" : state.vendor;

    // let { data } = await ItemsRepository.itemsModel({
    //   request: {
    //     method: "getSearchItems",
    //     data: {
    //       company_code: localStorage.getItem("companyCode"),
    //       search_item: text,
    //       vendor: vendorName,
    //     },
    //   },
    // });

    // let items = data.response.data.items;
    if (items?.length > 0) {
      let newArray = JSON.parse(JSON.stringify(items));
      newArray.forEach((a) => {
        if (checkIds[a._id]) {
          a.selected = true;
        }
      });
      setState((prev) => ({
        ...prev,
        searchedItems: newArray,
        loading: false,
        isSearched: "",
      }));
    } else {
      setState((prev) => ({
        ...prev,
        searchedItems: [],
        isSearched: "empty",
      }));
    }
  };

  const handleSale = () => {
    let tokenType = localStorage.getItem("tokenType");
    if (tokenType == "user") {
      history.push({
        pathname: "/inventory/dashboard/outgoing/sell",
      });
    } else {
      history.push({
        pathname: "/inventory/admin/outgoing/sell",
      });
    }
  };

  const handleClear = () => {
    dispatch(clearSelected());
    setState((prev) => ({
      ...prev,
      searchedItems: [],
      searchKey: "",
      vendor: "all",
      isSearched: "",
      loading: !prev.loading,
    }));
  };

  const searchItems = useMemo(() => {
    // console.log("searchedItems");
    if (state.searchedItems.length > 0) {
      console.log("1st IF");

      let newArray = JSON.parse(JSON.stringify(state.searchedItems));
      newArray.sort((a, b) => {
        if (checkIds[a._id]) {
          a.selected = true;
        }
        if (checkIds[b._id]) {
          b.selected = true;
        }
        if (a.selected === b.selected) return 0;
        if (a.selected) return -1;
        return 1;
      });
      return newArray;
    } else if (state.isSearched === "empty") {
      // console.log("2nd IF");
      return [];
    } else {
      console.log("last IF");
      // console.log("itemm arrray", state.items);

      let newArray = JSON.parse(JSON.stringify(inventory));
      newArray.sort((a, b) => {
        if (checkIds[a._id]) {
          a.selected = true;
        }
        if (checkIds[b._id]) {
          b.selected = true;
        }
        if (a.selected === b.selected) return 0;
        if (a.selected) return -1;
        return 1;
      });
      // console.log("newArray", newArray);
      return newArray;
    }
  }, [state.searchedItems, state.isSearched, inventory]);

  const searchItemsMemoized = useMemo(() => {
    // console.log('Recalculating searchItemsMemoized');
    return searchItems;
  }, [state.isSearched, inventory]);

  // console.log(searchItemsMemoized, "searchItemsMemoized");

  const handleInput = (e) => {
    const { name, value } = e.target;
    console.log("name", name);
    console.log("value", value);

    if (name === "searchKey") {
      if (searchKeyRef.current) {
        searchKeyRef.current.value = value;
      }
      setState((prev) => ({
        ...prev,
        searchKey: value,
      }));
      // console.log(searchKeyRef.current.value);
    } else {
      setState((prev) => {
        const newState = { ...prev, [name]: value };
        return newState;
      });
    }
  };

  const handleUpdate = (arg, name, index) => {
    console.log("handleUpdatefunction");
    let item = JSON.parse(JSON.stringify(arg));
    let updated = JSON.parse(JSON.stringify(arg));
    updated.selected = false;
    delete updated.saleQuantity;
    try {
      if (name === "saleQuantity") {
        let found = checkIds[item._id];
        if (found) {
          let idx = selectedItems.findIndex((i) => i._id === item._id);
          dispatch(editItem({ index: idx, key: name, value: item[name] }));
          setState((prev) => ({
            ...prev,
            searchKey: "",
            searchedItems: [],
          }));
        }
      } else {
        let idx = selectedItems.findIndex((i) => i._id === item._id);
        if (idx !== -1) {
          dispatch(editItem({ index: idx, key: name, value: item[name] }));
        }
        dispatch(
          editSearchedItem({
            item: { ...item, selected: false },
            key: name,
            value: item[name],
          })
        );
        toast.configure();
        toast.success("Updated Successfully");
        updateItemsDisc([updated], dispatch, []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleEdit = (e, indx, item) => {
    console.log("handleEdit");
    let { value, name } = e.target;
    let searchedItems = JSON.parse(JSON.stringify(state.searchedItems));
    if (state.searchedItems.length > 0) {
      let found = searchedItems.find((i) => i._id === item._id);
      if (found) {
        found[name] = value;
      } else {
        searchedItems.unshift(item);
      }
    }
    let items = JSON.parse(JSON.stringify(inventory));
    let found = items.find((i) => i._id === item._id);
    if (found) {
      found[name] = value;
    } else {
      items.unshift(item);
    }
    setState((prev) => ({ ...prev, items, searchedItems }));
  };

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      e.target.blur();
    }
  };

  return (
    <Box>
      <Header className="mt-20">
        <TopGrid
          container
          alignItems="center"
          spacing={1}
          sx={{ mt: { md: "10px", xs: "40px" } }}
        >
          <Grid item md={3} xs={9} sx={{ ml: { md: "0px", xs: "-20px" } }}>
            {/* <Search
              name={"searchKey"}
              text={"Search item..."}
              defaultValue={searchKeyRef.current}
              onChange={handleInput}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch(searchKeyRef.current.value, state.vendor);
                }
              }}
              inputRef={searchKeyRef}
            /> */}
            <SearchNew
              handleSearch={handleSearch}
              // name={"searchKey"}
              // text={"Search item..."}
              // defaultValue={searchKeyRef.current}
              // onChange={handleInput}
              // onKeyDown={(e) => {
              //   if (e.key === 'Enter') {
              //     handleSearch(searchKeyRef.current.value, state.vendor);
              //   }
              // }}
              // inputRef={searchKeyRef}
            />
          </Grid>

          <Grid align="center" item lg={5} md={4} sm={2} xs={3}>
            <Typography
              sx={{
                lineHeight: 1,
                color: "white",
                fontSize: { md: "24px", xs: "16px" },
              }}
            >
              Sale Items
            </Typography>
          </Grid>
          <Grid
            align="center"
            item
            lg={2}
            md={3}
            xs={12}
            sx={{ ml: { md: "0px", xs: "-20px" } }}
          >
            <FormControl fullWidth size="small">
              <InputLabel>Items Brands</InputLabel>
              <Select
                name="vendor"
                label="Items Brands"
                onChange={handleInput}
                defaultValue=""
                sx={{ background: "white" }}
              >
                <MenuItem value="all">All</MenuItem>
                {vendor?.vendors?.map((item, index) => (
                  <MenuItem key={index} value={item?.companyName}>
                    {item?.companyName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            align="center"
            item
            md={1}
            xs={6}
            sx={{ ml: { md: "0px", xs: "-20px" } }}
          >
            <ButtonAdd fullWidth onClick={handleSale}>
              Sale
            </ButtonAdd>
          </Grid>
          <Grid align="center" item md={1} xs={6}>
            <ButtonAdd fullWidth onClick={handleClear}>
              Clear
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>

      <BodyContainer>
        <Grid container>
          <Grid item md={5} style={{ background: "white", padding: "20px" }}>
            <Box style={{ maxHeight: "300px", overflowY: "auto" }}>
              <Typography variant="h6" sx={{ color: "#757575" }}>
                Selected Items : {selectedItems.length}
              </Typography>

              <Table aria-label="simple table">
                <TableHead>
                  <TableRow style={{ height: "15px" }}>
                    <TableCell width="25px">#</TableCell>
                    <TableCell width="320px">Name</TableCell>
                    <TableCell>Qty</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedItems?.map((item, index) => (
                    <TableRow height="10px" key={index}>
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell width="320px" component="th" scope="row">
                        {item.name}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {item.saleQuantity ? item.saleQuantity : 1}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Grid>
        </Grid>

        {inventory?.length === 0 &&
          inventory.length === 0 &&
          loading === false && (
            <Typography
              variant="h6"
              sx={{ textAlign: "center", color: "#4eaf51" }}
            >
              No Items
            </Typography>
          )}
        {state.searchedItems.length === 0 && state.isSearched === "empty" && (
          <Typography variant="h6" sx={{ color: "#4eaf51" }}>
            No Items Found
          </Typography>
        )}

        {searchItems.map((item, index) => {
          // console.log("searched");
          // console.log('item', item)

          const costPriceBatchInside =
            item?.batchNumber?.[0]?.newItem?.costPrice ?? null;
          const salePriceBatchInside =
            item?.batchNumber?.[0]?.newItem?.price ?? null;
          console.log("costPriceBatchInside", costPriceBatchInside);
          console.log("salePriceBatchInside", salePriceBatchInside);
          console.log("batchhhh", item.batchNumber);

          return (
            <Row
              key={item._id}
              item={item}
              index={index}
              handleSelection={handleSelection}
              companyCode={companyCode}
              editFeature={editFeature}
              checkIds={checkIds}
              handleUpdate={handleUpdate}
              handleEdit={handleEdit}
              BoxesPacking={BoxesPacking}
              RFTfeature={RFTfeature}
              handleKeyUp={handleKeyUp}
              selectedItems={selectedItems}
              tokenType={tokenType}
              costPriceShow={showCostPrice}
              costPriceBatchInside={costPriceBatchInside}
              salePriceBatchInside={salePriceBatchInside}
            />
          );
        })}

        {inventory.length > 0 && inventory.length > 3000 && (
          <Button onClick={getInventory}>LOAD MORE</Button>
        )}

        <Loader loading={loading} />
      </BodyContainer>
    </Box>
  );
});

export default SelectItems;
